import React from "react";
import ProductPage from "./ProductPage";

const coffeeTables = [
  {
    id: 1,
    title: "Modern Coffee Table",
    description: "Stylish modern coffee table",
    image: "/images/coffee-table/table1.png",
  },
  {
    id: 2,
    title: "Wooden Coffee Table",
    description: "Classic wooden coffee table",
    image: "/images/coffee-table/table2.png",
  },
  {
    id: 3,
    title: "Glass Coffee Table",
    description: "Elegant glass top coffee table",
    image: "/images/coffee-table/table3.png",
  },
];

const CoffeeTablePage = () => {
  return (
    <ProductPage
      title="Coffee Table Collection"
      subtitle="Discover stylish coffee tables"
      bannerImage="/images/coffee-table-banner.jpg"
      products={coffeeTables}
    />
  );
};

export default CoffeeTablePage;